import apiClient from './apiClient';

// Presence status enum mapping must match backend PresenceStatus
export const PresenceStatus = {
  Offline: 0,
  Idle: 1,
  InTest: 2,
};

let heartbeatTimer = null;
let currentStatus = PresenceStatus.Idle;
let currentContextProvider = null; // () => ({ testId, testName })

async function sendHeartbeatOnce(status = currentStatus, ctx = {}) {
  try {
    const payload = {
      status,
      testId: ctx.testId ?? null,
      testName: ctx.testName ?? null,
    };
    const res = await apiClient.post('/presence/heartbeat', payload);
    const ttl = res?.data?.ttlSeconds || res?.data?.TtlSeconds || 60;
    return Math.max(10, Math.floor(ttl * 0.5));
  } catch (e) {
    // Swallow errors; auth or network may fail transiently
    return 30; // sensible default seconds until next try
  }
}

export function stopAutoHeartbeat() {
  if (heartbeatTimer) {
    try { clearInterval(heartbeatTimer); } catch {}
    heartbeatTimer = null;
  }
}

export async function startAutoHeartbeat(initialStatus, contextProvider) {
  stopAutoHeartbeat();
  currentStatus = initialStatus ?? PresenceStatus.Idle;
  currentContextProvider = typeof contextProvider === 'function' ? contextProvider : () => ({ testId: null, testName: null });

  // Send immediately, then schedule by TTL/2
  const firstDelay = await sendHeartbeatOnce(currentStatus, currentContextProvider());
  const intervalMs = Math.max(10000, firstDelay * 1000);
  heartbeatTimer = setInterval(async () => {
    const nextDelaySec = await sendHeartbeatOnce(currentStatus, currentContextProvider());
    // Optionally adapt interval on the fly if TTL changes significantly
    // For simplicity, keep fixed during this session
  }, intervalMs);
}

export async function setStatus(status) {
  currentStatus = status;
  // Fire-and-forget immediate heartbeat reflecting new status
  await sendHeartbeatOnce(currentStatus, currentContextProvider ? currentContextProvider() : {});
}

export default {
  PresenceStatus,
  startAutoHeartbeat,
  stopAutoHeartbeat,
  setStatus,
};
